// @ utilities
import { formatText } from 'core/i18n';
// @ constants
const {
    ACTIVE_CLASS_EQUITY_ID,
    ACTIVE_CLASS_FIXED_INCOME_ID,
    ACTIVE_CLASS_MONEY_MARKET_ID,
    ACTIVE_CLASS_REAL_ASSETS_ID,
} = require('constants/RAConstants/index');

const getAssetClassName = assetClassId => {
    return formatText(`raGlobal-raGlobal_asset${assetClassId}`);
};

const getEmptyStateAssets = () => {
    return [
        {
            assetClassId: ACTIVE_CLASS_MONEY_MARKET_ID,
            assetClass: getAssetClassName(ACTIVE_CLASS_MONEY_MARKET_ID),
            weight: 0,
        },
        {
            assetClassId: ACTIVE_CLASS_FIXED_INCOME_ID,
            assetClass: getAssetClassName(ACTIVE_CLASS_FIXED_INCOME_ID),
            weight: 0,
        },
        {
            assetClassId: ACTIVE_CLASS_EQUITY_ID,
            assetClass: getAssetClassName(ACTIVE_CLASS_EQUITY_ID),
            weight: 0,
        },
        {
            assetClassId: ACTIVE_CLASS_REAL_ASSETS_ID,
            assetClass: getAssetClassName(ACTIVE_CLASS_REAL_ASSETS_ID),
            weight: 0,
        },
    ];
};

const getBarColor = assetClassId => {
    const assetsIds = {
        [ACTIVE_CLASS_MONEY_MARKET_ID]: '#405cd6',
        [ACTIVE_CLASS_FIXED_INCOME_ID]: '#0c9fac',
        [ACTIVE_CLASS_EQUITY_ID]: '#DD2774',
        [ACTIVE_CLASS_REAL_ASSETS_ID]: '#A77ACC',
    };

    return assetsIds[assetClassId] || '';
};

export default {
    getAssetClassName,
    getEmptyStateAssets,
    getBarColor,
};
